import { ChevronRight } from '@styled-icons/material';
import { shouldForwardProp } from '@trmediaab/zebra';
import styled from 'styled-components';

import createStyledIcon from './createStyledIcon';

export type Direction = 'up' | 'right' | 'down' | 'left';

export interface ChevronProps {
  direction?: Direction;
  transition?: boolean;
}

const getRotation = (direction: Direction) => {
  switch (direction) {
    case 'up':
      return 'rotate(-90deg)';
    case 'down':
      return 'rotate(90deg)';
    case 'left':
      return 'rotate(180deg)';
    default:
      return;
  }
};

const Chevron = styled(
  createStyledIcon<ChevronProps, typeof ChevronRight>(ChevronRight),
).withConfig({
  shouldForwardProp: (prop, target) =>
    // Filter out `direction` because it's a known svg attribute
    // with a different meaning
    prop !== 'direction' && shouldForwardProp(prop, target),
})<ChevronProps>`
  transform: ${(props: ChevronProps) =>
    getRotation(props.direction || 'right')};
  transition: transform ${({ transition = true }) => (transition ? 0.2 : 0)}s
    ease-in-out;
`;

export default Chevron;
